

const LoadingSpinner = () => {
    return (
        <i className="fa-solid fa-spinner rotating"></i>
    )
}

export default LoadingSpinner;